import {
  CollectionBuilderComponent,
  overrideBuilderModel,
} from '@techstyle/react-builder-models';

export const overrides = {
  defaultStyles: {
    marginTop: '0px',
  },
  inputs: [
    {
      name: 'constructorCollectionId',
      friendlyName: 'Constructor Collection ID',
    },
    {
      name: 'showBlockPositions',
      helperText:
        'If true, a small number will be shown on top of the block, for easier usage when there are a lot of blocks. Only shown on the Builder editor.',
      type: 'boolean',
      defaultValue: false,
      advanced: true,
    },
    {
      name: 'isCarousel',
      type: 'boolean',
      advanced: true,
      defaultValue: false,
    },
    {
      name: 'productSettings',
      friendlyName: 'Product Settings',
      type: 'object',
      subFields: [
        {
          name: 'backgroundCategoryIds',
          type: 'list',
          subFields: [
            {
              name: 'backgroundCategoryId',
              type: 'number',
              required: true,
            },
          ],
        },
        {
          name: 'fpls',
          type: 'list',
          subFields: [
            {
              name: 'fpl',
              type: 'number',
              required: true,
            },
          ],
        },
        {
          name: 'backgroundFplIds',
          type: 'list',
          subFields: [
            {
              name: 'backgroundFplId',
              type: 'number',
              required: true,
            },
          ],
        },
        {
          name: 'backgroundFplCodes',
          type: 'list',
          subFields: [
            {
              name: 'backgroundFplCode',
              type: 'string',
              required: true,
            },
          ],
        },
        {
          name: 'defaultTagId',
          type: 'number',
        },
        {
          name: 'filters',
          type: 'list',
          defaultValue: null,
          subFields: [
            {
              name: 'filter',
              type: 'string',
              required: true,
              enum: [
                'size_bra',
                'size_bralette',
                'size_undie',
                'size_lingerie',
                'size_sport',
                'size_all_gender_top',
                'size_all_gender_bottom',
                'size',
                'color',
                'fabric',
                'collection',
              ],
            },
          ],
        },
        {
          name: 'productSource',
          type: 'string',
        },
        {
          name: 'label',
          type: 'string',
        },
        {
          name: 'header',
          type: 'string',
        },
        {
          name: 'maxItemCount',
          type: 'number',
        },
        {
          name: 'excludeFpls',
          type: 'list',
          subFields: [
            {
              name: 'excludeFpl',
              type: 'number',
              required: false,
            },
          ],
        },
        {
          name: 'excludeTagIds',
          type: 'list',
          subFields: [
            {
              name: 'excludeTagId',
              type: 'number',
              required: false,
            },
          ],
        },
        {
          name: 'excludeMasterProductIds',
          type: 'list',
          subFields: [
            {
              name: 'excludeMasterProductId',
              type: 'number',
              required: false,
            },
          ],
        },
      ],
    },
    {
      name: 'gridOptions',
      friendlyName: 'Grid Options',
      type: 'object',
      defaultValue: {
        showDescriptiveText: true,
      },
      subFields: [
        {
          name: 'blocks',
          type: 'list',
          copyOnAdd: false,
          broadcast: true,
          subFields: [
            {
              name: 'content',
              type: 'uiBlocks',
              defaultValue: [],
            },
            {
              name: 'uiHelper',
              helperText:
                'Only used to display a title on each block inside the Builder editor.',
              type: 'string',
              defaultValue: 'Position',
              hidden: true,
            },
            {
              name: 'position',
              type: 'string',
              defaultValue: 1,
            },
            {
              name: 'width',
              type: 'number',
              defaultValue: 1,
            },
            {
              name: 'height',
              type: 'number',
              defaultValue: 1,
            },
            {
              name: 'widthMobile',
              helperText:
                'If empty, value will be ignored and width on mobile will be automatically set.',
              type: 'number',
              defaultValue: null,
            },
            {
              name: 'heightMobile',
              helperText:
                'If empty, value will be ignored and height on mobile will be automatically set.',
              type: 'number',
              defaultValue: null,
            },
          ],
          defaultValue: [],
        },
        {
          name: 'gridAssetContainer',
          type: 'string',
        },
        {
          name: 'gridAssetContainerMobile',
          type: 'string',
        },
        {
          name: 'sideNav',
          friendlyName: 'Side Nav Settings',
          type: 'object',
          subFields: [
            {
              name: 'showSideNav',
              type: 'boolean',
              defaultValue: false,
              helperText: 'Ignored on Carousel grids',
            },
            {
              name: 'showHeaderLabel',
              type: 'boolean',
              defaultValue: true,
            },
            {
              name: 'showSort',
              type: 'boolean',
              defaultValue: false,
            },
            {
              name: 'showHeader',
              type: 'boolean',
              defaultValue: false,
            },
            {
              name: 'showBreadcrumbs',
              type: 'boolean',
              defaultValue: false,
            },
          ],
        },
        {
          name: 'elementsToHide',
          defaultValue: {
            colorsAvailable: false,
            flags: false,
            overlay: false,
            price: false,
            promo: false,
            reviewStars: false,
            wishlist: false,
          },
          type: 'object',
          subFields: [
            {
              name: 'colorsAvailable',
              type: 'boolean',
              defaultValue: true,
            },
            {
              name: 'flags',
              type: 'boolean',
              defaultValue: true,
            },
            {
              name: 'price',
              type: 'boolean',
              defaultValue: true,
            },
            {
              name: 'promo',
              type: 'boolean',
              defaultValue: true,
            },
            {
              name: 'wishlist',
              type: 'boolean',
            },
          ],
        },
        {
          name: 'inlineSizeCategory',
          type: 'string',
          enum: ['All', 'Bras', 'Bralettes', 'Undies', 'Lingerie', 'Sleep'],
          defaultValue: null,
        },
        {
          name: 'inlineSizeAsset',
          type: 'boolean',
          defaultValue: false,
        },
        {
          name: 'showDescriptiveText',
          type: 'boolean',
          defaultValue: true,
        },
        {
          name: 'showLaydown',
          type: 'boolean',
          defaultValue: false,
        },
        {
          name: 'shouldTrackProductPriceViewed',
          type: 'boolean',
          defaultValue: false,
          helperText:
            "Send 'Product Price Viewed' event when price comes into view.",
        },
      ],
    },
    {
      name: 'carouselOptions',
      advanced: true,
      defaultValue: {
        arrows: false,
        dots: false,
        autoplay: false,
      },
      showIf: (options: any) => options.get('isCarousel') === true,
      type: 'object',
      subFields: [
        {
          name: 'arrows',
          type: 'boolean',
          defaultValue: false,
        },
        {
          name: 'arrowsOffset',
          type: 'number',
          helperText: 'If left unset, 32px will be used.',
          defaultValue: null,
        },
        {
          name: 'arrowColor',
          type: 'color',
          defaultValue: null,
        },
        {
          name: 'dots',
          type: 'boolean',
          defaultValue: false,
        },
        {
          name: 'autoplay',
          type: 'boolean',
          defaultValue: false,
        },
      ],
    },
    {
      name: 'sortList',
      type: 'list',
      localized: false,
      friendlyName: 'Sort Dropdown Options',
      helperText:
        'The first sort option in your list will be set as the default sort in the sort dropdown.  Drag the sort options to prioritize',
      defaultValue: '',
      subFields: [
        {
          name: 'filterLabel',
          friendlyName: 'Sort Label',
          type: 'string',
          defaultValue: '',
          helperText: 'Applies to both Sort Options and Custom Sort Lists',
        },
        {
          name: 'sortOption',
          friendlyName: 'Sort Option',
          type: 'string',
          localized: false,
          required: false,
          defaultValue: '',
          enum: [
            '',
            'bestsellers',
            'fplSort',
            'fplasc',
            'newest',
            'priceHighToLow',
            'priceLowToHigh',
            'topReviewed',
            'bras',
            'panties',
          ],
        },
      ],
    },
    {
      name: 'constructorSortList',
      type: 'list',
      localized: false,
      friendlyName: 'Constructor Sort Dropdown Options',
      helperText:
        'The first sort option in your list will be set as the default sort in the sort dropdown.  Drag the sort options to prioritize',
      defaultValue: '',
      subFields: [
        {
          name: 'filterLabel',
          friendlyName: 'Sort Label',
          type: 'string',
          defaultValue: '',
          helperText: 'Applies to both Sort Options and Custom Sort Lists',
        },
        {
          name: 'sortOption',
          friendlyName: 'Sort Option',
          type: 'string',
          localized: false,
          required: false,
          defaultValue: '',
          enum: [
            '',
            'relevance',
            'bestsellers',
            'newest',
            'priceh2l',
            'pricel2h',
          ],
        },
      ],
    },
  ],
};
export const excludeInputs = [
  'sideNav',
  'label',
  'gridAssetContainer',
  'gridAssetContainerMobile',
  'maxItemCount',
  'productSource',
  'fpls',
  'backgroundFplIds',
  'backgroundFplCodes',
  'backgroundCategoryIds',
  'filters',
  'productSource',
  'inlineSizeCategory',
  'inlineSizeAsset',
  'excludeFpls',
  'excludeTagIds',
  'excludeMasterProductIds',
  'fplGlobalCodes',
  'productCategoryIds',
  'tagIds',
  'productTypeIds',
  'includeOutOfStock',
  'brand',
  'gridSortFeature',
  'sort',
  'gridCTA',
  'excludePreorderProducts',
];

const SXFCollectionBuilderComponent = overrideBuilderModel({
  base: CollectionBuilderComponent,
  overrides,
  excludeInputs,
});

export const BuilderCollectionConfig = {
  ...SXFCollectionBuilderComponent,
  canHaveChildren: true,
};
